export const FETCH_CREATE_DOCUMENT_SUCCESS = "FETCH_CREATE_DOCUMENT_SUCCESS";
export const LOADING_CREATE_DOCUMENT = "LOADING_CREATE_DOCUMENT";
